import { render, staticRenderFns } from "./NewsDetailHeader.vue?vue&type=template&id=44a42448&"
import script from "./NewsDetailHeader.vue?vue&type=script&lang=ts&"
export * from "./NewsDetailHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports